export const hasProjectOrderNumber = (value?: string) => Boolean(value?.trim())
